import { render, staticRenderFns } from "./HWP_Archive.vue?vue&type=template&id=494bc908&scoped=true&"
import script from "./HWP_Archive.vue?vue&type=script&lang=js&"
export * from "./HWP_Archive.vue?vue&type=script&lang=js&"
import style0 from "./HWP_Archive.vue?vue&type=style&index=0&id=494bc908&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494bc908",
  null
  
)

export default component.exports